const confirmButtonText = {
  id: 'globals.confirm',
};

const label = {
  id: 'globals.minutes',
};

const title = {
  id: 'supportReasonsDialog.title',
};

const description = {
  id: 'supportReasonsDialog.description',
};

const textIds = {
  confirmButtonText,
  description,
  label,
  title,
};

export default textIds;
